export default "__VITE_ASSET__Djz0oCC0__"